module.exports = __webpack_public_path__ + "assets/img/tag_list-2813aa18.png";